<template>
  <v-layout row wrap>
    <v-container fluid background>
      <v-card-text>
        <v-container fluid pa-2 style="background-color:#fff;border-radius:10px;">
          <v-layout row wrap pa-4>
            <v-flex xs12>
              <h2>{{ $t("Calculation_income") }}</h2>
              <v-layout row wrap>
                <v-flex lg1 md2 sm2 xs4 pa-3>
                  <h4>{{ $t("Year_tax") }}</h4>
                </v-flex>
                <v-flex lg2 md2 sm2 xs8 px-1>
                  <v-select v-model="years" :items="items" item-text="name" item-value="name" @input="getTaxDetail()"></v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap style="display:none">
                <v-flex lg1 md3 sm3 xs4 pa-3>
                  <span>{{ $t("Otherincome") }}</span>
                  <!-- <v-text-field :label="$t('Otherincome')" v-model="model_tax.name" ></v-text-field> -->
                </v-flex>
                <v-flex lg2 md3 sm3 xs8 px-3>
                  <v-text-field placeholder="0" type="number" v-model="income" />
                </v-flex>
              </v-layout>
              <h4>{{ $t("Deductible") }}</h4>
              <v-layout row wrap>
                <v-flex lg1 md2 sm2 xs5 px-1>
                  <span>{{ $t("Lessexpenses") }}{{ $t("Rate") }}</span>
                </v-flex>
                <v-flex lg1 md2 sm2 xs6 px-1>
                  <v-text-field label="Solo" placeholder="tax" type="number" v-model="taxsetting.less_exp_rate" solo />
                </v-flex>
                <v-flex lg1 md2 sm2 xs1 px-1>
                  <span>%</span>
                </v-flex>
                <v-flex lg1 md2 sm2 xs3 px-1>
                  <span>{{ $t("max_value") }}</span>
                </v-flex>
                <v-flex lg2 md2 sm2 xs8 px-1>
                  <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.less_exp_base" solo />
                </v-flex>
                <v-flex lg2 md2 sm2 xs1 px-1>
                  <span>{{ currency_symbols }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg3 md3 sm3 xs4>
                  <span>{{ $t("personal") }}</span>
                </v-flex>
                <v-flex lg1 md3 sm3 xs3>
                  <span>{{ $t("max_value") }}</span>
                </v-flex>
                <v-flex lg2 md3 sm3 xs4>
                  <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_person" solo />
                </v-flex>
                <v-flex lg3 md3 sm3 xs1 pa-2>
                  <span>{{ currency_symbols }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg3 md3 sm3 xs4>
                  <span>{{ $t("spouse") }}</span>
                </v-flex>
                <v-flex lg1 md3 sm3 xs3>
                  <span>{{ $t("max_value") }}</span>
                </v-flex>
                <v-flex lg2 md3 sm3 xs4>
                  <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_spouse" solo />
                </v-flex>
                <v-flex lg3 md3 sm3 xs1 pa-2>
                  <span>{{ currency_symbols }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg3 md3 sm3 xs4>
                  <span>{{ $t("childen") }}</span>
                </v-flex>
                <v-flex lg1 md3 sm3 xs3>
                  <span>{{ $t("max_value") }}</span>
                </v-flex>
                <v-flex lg2 md3 sm3 xs4>
                  <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_child_base" solo />
                </v-flex>
                <v-flex lg3 md3 sm3 xs1 pa-2>
                  <span>{{ currency_symbols }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg3 md3 sm3 xs4>
                  <span>{{ $t("residence") }}</span>
                </v-flex>
                <v-flex lg1 md3 sm3 xs3>
                  <span>{{ $t("max_value") }}</span>
                </v-flex>
                <v-flex lg2 md3 sm3 xs4>
                  <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_insurance_base" solo />
                </v-flex>
                <v-flex lg3 md3 sm3 xs1 pa-2>
                  <span>{{ currency_symbols }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg3 md3 sm3 xs4>
                  <span>{{ $t("parent") }}</span>
                </v-flex>
                <v-flex lg1 md3 sm3 xs3>
                  <span>{{ $t("max_value") }}</span>
                </v-flex>
                <v-flex lg2 md3 sm3 xs4>
                  <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_parent_base" solo />
                </v-flex>
                <v-flex lg3 md3 sm3 xs1 pa-2>
                  <span>{{ currency_symbols }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg3 md3 sm3 xs4>
                  <span>{{ $t("handicapped") }}</span>
                </v-flex>
                <v-flex lg1 md3 sm3 xs3>
                  <span>{{ $t("max_value") }}</span>
                </v-flex>
                <v-flex lg2 md3 sm3 xs4>
                  <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_handucap_base" solo />
                </v-flex>
                <v-flex lg3 md3 sm3 xs1 pa-2>
                  <span>{{ currency_symbols }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg3 md3 sm3 xs4>
                  <span>{{ $t("insurance") }}</span>
                </v-flex>
                <v-flex lg1 md3 sm3 xs3>
                  <span>{{ $t("max_value") }}</span>
                </v-flex>
                <v-flex lg2 md3 sm3 xs4>
                  <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_inc_residence_base" solo />
                </v-flex>
                <v-flex lg3 md3 sm3 xs1 pa-2>
                  <span>{{ currency_symbols }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg3 md3 sm3 xs4>
                  <span>{{ $t("parent_insurance") }}</span>
                </v-flex>
                <v-flex lg1 md3 sm3 xs3>
                  <span>{{ $t("max_value") }}</span>
                </v-flex>
                <v-flex lg2 md3 sm3 xs4>
                  <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_parent_insurance_base" solo />
                </v-flex>
                <v-flex lg3 md3 sm3 xs1 pa-2>
                  <span>{{ currency_symbols }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg3 md3 sm3 xs4>
                  <span>{{ $t("LTF") }}</span>
                </v-flex>
                <v-flex lg1 md3 sm3 xs3>
                  <span>{{ $t("max_value") }}</span>
                </v-flex>
                <v-flex lg2 md3 sm3 xs4>
                  <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_ltf" solo />
                </v-flex>
                <v-flex lg3 md3 sm3 xs1 pa-2>
                  <span>{{ currency_symbols }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg3 md3 sm3 xs4>
                  <span>{{ $t("long_insurance") }}</span>
                </v-flex>
                <v-flex lg1 md3 sm3 xs3>
                  <span>{{ $t("max_value") }}</span>
                </v-flex>
                <v-flex lg2 md3 sm3 xs4>
                  <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_long_insurance" solo />
                </v-flex>
                <v-flex lg3 md3 sm3 xs1 pa-2>
                  <span>{{ currency_symbols }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg3 md3 sm3 xs4>
                  <span>{{ $t("RMF") }}</span>
                </v-flex>
                <v-flex lg1 md3 sm3 xs3>
                  <span>{{ $t("max_value") }}</span>
                </v-flex>
                <v-flex lg2 md3 sm3 xs4>
                  <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_rmf" solo />
                </v-flex>
                <v-flex lg3 md3 sm3 xs1 pa-2>
                  <span>{{ currency_symbols }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <h3>{{ $t("Otherallowances") }}</h3>
              </v-layout>
              <v-layout row v-for="(item, index) in data_allowances" :key="index">
                <!-- <v-flex lg1 md4 sm4 xs4 pa-2>
                 <v-switch v-model="disabled" class="ma-2" :label="`ค่าใช้จ่าย 1: ${disabled.toString()}`"></v-switch>
                </v-flex>-->
                <v-flex lg4 md4 sm4 xs4 pa-2>
                  <v-text-field label="name" v-model="item.name" hide-details />
                </v-flex>
                <v-flex lg3 md4 sm4 xs4 pa-2>
                  <v-text-field :label="$t('max_value')" v-model="item.max" hide-details />
                </v-flex>
                <v-flex lg4 md4 sm4 xs4 pa-3>
                  <span>{{ $t("Maximum_value") }}</span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-layout row wrap py-2>
              <v-flex xs12>
                <v-btn color="success" @click="plusallowances()">
                  <v-icon :size="16">fa-plus</v-icon>
                  <span class="ml-2">{{ $t("Add_step") }}</span>
                </v-btn>
                <v-btn color="warning" @click="delallowances()">
                  <v-icon :size="16">fa-minus</v-icon>
                  <span class="ml-2">{{ $t("Step_down") }}</span>
                </v-btn>
              </v-flex>
            </v-layout>

            <v-flex xs12>
              <h2>{{ $t("Tax_structure") }}</h2>
              <div v-if="data_tax.length > 0">
                <v-layout row wrap v-for="(item, index) in data_tax" :key="index">
                  <v-flex md2 sm2 xs5 px-1>
                    <v-text-field :label="$t('Fromtheamount')" v-model="item.from_value" hide-details />
                  </v-flex>
                  <v-flex md1 sm1 xs1 px-1>
                    <h1 class="text-xs-center" style="padding-top: 0.5rem;">-</h1>
                  </v-flex>
                  <v-flex md2 sm2 xs5 px-1>
                    <v-text-field :label="$t('Toamount')" v-model="item.to_value" hide-details />
                  </v-flex>
                  <v-flex md1 sm1 xs1 px-1>
                    <h1 class="text-xs-center" style="padding-top: 0.5rem;">=</h1>
                  </v-flex>
                  <v-flex md2 sm2 xs4 px-1>
                    <v-text-field :label="$t('Rate')" v-model="item.tax" hide-details />
                  </v-flex>
                  <!-- {{item.line_number}} -->
                </v-layout>
              </div>
              <div v-else>
                <v-layout row wrap v-for="(item, index) in taxstructure" :key="index">
                  <v-flex md2 sm2 xs5 px-1>
                    <v-text-field :label="$t('Fromtheamount')" v-model="item.from_value" hide-details />
                  </v-flex>
                  <v-flex md1 sm1 xs1 px-1>
                    <h1 class="text-xs-center" style="padding-top: 0.5rem;">-</h1>
                  </v-flex>
                  <v-flex md2 sm2 xs5 px-1>
                    <v-text-field :label="$t('Toamount')" v-model="item.to_value" hide-details />
                  </v-flex>
                  <v-flex md1 sm1 xs1 px-1>
                    <h1 class="text-xs-center" style="padding-top: 0.5rem;">=</h1>
                  </v-flex>
                  <v-flex md2 sm2 xs4 px-1>
                    <v-text-field :label="$t('Rate')" v-model="item.tax" hide-details />
                  </v-flex>
                </v-layout>
              </div>
              <v-layout row wrap py-2>
                <v-flex xs12>
                  <v-btn color="success" @click="plusTax()">
                    <v-icon :size="16">fa-plus</v-icon>
                    <span class="ml-2">{{ $t("Add_step") }}</span>
                  </v-btn>
                  <v-btn color="warning" @click="delTax()">
                    <v-icon :size="16">fa-minus</v-icon>
                    <span class="ml-2">{{ $t("Step_down") }}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 text-xs-right v-if="permission_edit == true || admin == 'true'">
              <v-btn color="success" @click="checkdata == '' ? onSave() : onUpdate()">
                <v-icon>save</v-icon>
                <span class="px-2">{{ checkdata == "" ? $t("create") : $t("save") }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-snackbar v-model="snackbar" :timeout="3500" :top="'top'" :color="snackbarcolor">
            {{ snackmsg }}
            <v-btn dark flat @click="snackbar = false">X</v-btn>
          </v-snackbar>
        </v-container>
      </v-card-text>
    </v-container>
  </v-layout>
</template>
<script>
/* jshint ignore:start */
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import DocumentService from "@/services/DocumentService";
import moment from "moment";
import numeral from "numeral";
import SettingService from "@/services/SettingService";
import UserService from "@/services/UserService";
import { setTimeout } from "timers";
export default {
  props: {
    json_data: Object,
  },
  watch: {
    json_data(val) {
      if (val.data != null) {
        //this.form_model = val.data;
        this.getTaxDetail(val.data);
        //console.log("form_model" ,this.form_model)
      } else {
        //this.$refs.form.resetValidation();
        this.clearForm();
      }
    },
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
      //val && this.$nextTick(() => (this.listyear));
      //new Date().getFullYear()
    },
  },
  data: () => ({
    disabled: false,
    items: [],
    data_tax: [],
    data_allowances: [],
    year: null,
    years: { name: numeral(new Date().toISOString().substr(0, 4)).value() },
    //years : new Date().toISOString().substr(0, 4),
    menu: false,
    income: 0,
    jsondatatax: {
      year_tax: null,
      tax_detail: [],
      tax_cal: [],
      creator_code: null,
      company_id: localStorage._company_guid,
    },
    tax_detail: [
      {
        name: "add_income",
        type: 1,
        percent: 0,
        max: 0,
        company_id: localStorage._company_guid,
      },
      {
        name: "expensed",
        type: 0,
        percent: 50,
        max: 100000,
        company_id: localStorage._company_guid,
      },
      {
        name: "personal",
        type: 0,
        percent: 0,
        max: 60000,
        company_id: localStorage._company_guid,
      },
      {
        name: "spouse",
        type: 0,
        percent: 0,
        max: 100000,
        company_id: localStorage._company_guid,
      },
      {
        name: "childen",
        type: 0,
        percent: 0,
        max: 90000,
        company_id: localStorage._company_guid,
      },
      {
        name: "residence",
        type: 0,
        percent: 0,
        max: 100000,
        company_id: localStorage._company_guid,
      },
      {
        name: "parent",
        type: 0,
        percent: 0,
        max: 100000,
        company_id: localStorage._company_guid,
      },
      {
        name: "handicapped",
        type: 0,
        percent: 0,
        max: 100000,
        company_id: localStorage._company_guid,
      },
      {
        name: "insurance",
        type: 0,
        percent: 0,
        max: 100000,
        company_id: localStorage._company_guid,
      },
      {
        name: "parent_insurance",
        type: 0,
        percent: 0,
        max: 100000,
        company_id: localStorage._company_guid,
      },
      {
        name: "long_insurance",
        type: 0,
        percent: 0,
        max: 100000,
        company_id: localStorage._company_guid,
      },
      {
        name: "LTF",
        type: 0,
        percent: 0,
        max: 100000,
        company_id: localStorage._company_guid,
      },
      {
        name: "RMF",
        type: 0,
        percent: 0,
        max: 100000,
        company_id: localStorage._company_guid,
      },
    ],
    taxsetting: {
      less_exp_rate: 50,
      less_exp_base: 100000,
      reduce_person: 60000,
      reduce_spouse: 60000,
      reduce_child_base: 90000,
      reduce_parent_base: 60000,
      reduce_handucap_base: 30000,
      reduce_insurance_base: 100000,
      reduce_parent_insurance_base: 15000,
      reduce_inc_residence_base: 100000,
      reduce_ltf: 500000,
      reduce_long_insurance: 200000,
      reduce_rmf: 500000,
      company_id: localStorage._company_guid,
    },
    checkdata: {},
    taxstructure: [
      {
        line_number: 1,
        from_value: 0,
        to_value: 150000,
        tax: 0,
        basiccal: 0,
        deductline: 0,
        company_id: localStorage._company_guid,
      },
      {
        line_number: 2,
        from_value: 150001,
        to_value: 300000,
        tax: 5,
        basiccal: 0,
        deductline: 0,
        company_id: localStorage._company_guid,
      },
      {
        line_number: 3,
        from_value: 300001,
        to_value: 500000,
        tax: 10,
        basiccal: 0,
        deductline: 0,
        company_id: localStorage._company_guid,
      },
      {
        line_number: 4,
        from_value: 500001,
        to_value: 750000,
        tax: 15,
        basiccal: 0,
        deductline: 0,
        company_id: localStorage._company_guid,
      },
      {
        line_number: 5,
        from_value: 750001,
        to_value: 1000000,
        tax: 20,
        basiccal: 0,
        deductline: 0,
        company_id: localStorage._company_guid,
      },
      {
        line_number: 6,
        from_value: 1000001,
        to_value: 2000000,
        tax: 25,
        basiccal: 0,
        deductline: 0,
        company_id: localStorage._company_guid,
      },
      {
        line_number: 7,
        from_value: 2000001,
        to_value: 5000000,
        tax: 30,
        basiccal: 0,
        deductline: 0,
        company_id: localStorage._company_guid,
      },
      {
        line_number: 8,
        from_value: 5000001,
        to_value: 0,
        tax: 35,
        basiccal: 0,
        deductline: 0,
        company_id: localStorage._company_guid,
      },
    ],
    currency_symbols: null,
    snackbarcolor: "red",
    snackbar: false,
    snackmsg: "",
    snack_type: "",
    permission_edit: false,
    permission_view: false,
    admin: false,
    empCode: localStorage._empcode,
    permission: [],
  }),
  created: async function() {
    console.log(this.years.name);
    this.admin = localStorage._is_admin;
    await UserService.getpermissionByusercode(this.empCode)
      .then((res) => {
        this.permission = res.data.permission;
        console.log(res);
      })
      .catch((err) => {});
    await this.checkpermission("TaxSettingList");
    console.log(this.check_permission);
    this.commitSetToolbar({ patternTool: "2" });
    this.getTaxSetting();
    this.createyear();
    this.getTaxDetail();
    this.data_allowances.push(
      {
        type: 0,
        percent: 0,
        name: null,
        max: 0,
      },
      {
        type: 0,
        percent: 0,
        name: null,
        max: 0,
      },
      {
        type: 0,
        percent: 0,
        name: null,
        max: 0,
      }
    );
  },
  destroyed: function() {
    this.commitToggleAlertDialog({ status: false, message: Object });
  },
  computed: {
    ...mapState("app", ["showLoading"]),
    ...mapState("permissionmenu", ["permission_List"]),
  },
  methods: {
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    closeDialog() {
      this.clearForm();
      this.$emit("close-dialog");
    },
    checkpermission(page) {
      let checkEdit = false;
      let checkView = false;
      if (this.permission_List.length != 0) {
        this.permission_List.forEach((element) => {
          if (page == element.module_name) {
            checkEdit = element.edit;
            checkView = element.reads;
          }
        });
      } else {
        checkEdit = false;
        checkView = false;
      }
      this.permission_edit = checkEdit;
      this.permission_view = checkView;
    },
    getTaxSetting() {
      this.commitSetShowLoading(true);
      SettingService.getGeneralSetting().then((res) => {
        this.currency_symbols = res.data.content[0].currency_symbols;
      });
      SettingService.getTaxSetting()
        .then((res) => {
          console.log("taxsetting: ", res.data.content.length);
          console.log("taxstructure: ", this.taxstructure);
          this.data_tax = [];
          console.log("taxstructure: ", res.data)
          if (res.data.content.length > 0) {
            console.log("if: ");
            console.log(res);
            for (let index = 0; index < this.taxstructure.length; index++) {
              this.data_tax.push({
                line_number: this.taxstructure[index].line_number,
                from_value: this.taxstructure[index].from_value,
                to_value: this.taxstructure[index].to_value,
                tax: this.taxstructure[index].tax,
                basiccal: this.taxstructure[index].basiccal,
                deductline: this.taxstructure[index].deductline,
                company_id: localStorage._company_guid,
              });
              console.log("index: ", index);
            }
            // for (let index = 0; index < res.data.content.length; index++) {
            //   this.data_tax.push({
            //     line_number: this.taxstructure[index].line_number,
            //     from_value: res.data.content[index].from_value,
            //     to_value: res.data.content[index].to_value,
            //     tax: res.data.content[index].tax,
            //     basiccal: res.data.content[index].basiccal,
            //     deductline: res.data.content[index].deductline,
            //     company_id: localStorage._company_guid,
            //   });
            //   console.log("index: ", index);
            // }
            console.log("data tax: ", this.data_tax);
          } else  {
            console.log("not data: ", res);

            for (let index = 0; index < this.taxstructure.length; index++) {
              this.data_tax.push({
                line_number: this.taxstructure[index].line_number,
                from_value: this.taxstructure[index].from_value,
                to_value: this.taxstructure[index].to_value,
                tax: this.taxstructure[index].tax,
                basiccal: this.taxstructure[index].basiccal,
                deductline: this.taxstructure[index].deductline,
                company_id: localStorage._company_guid,
              });
              console.log("data_tax: ", this.data_tax);
            }
            console.log(this.taxstructure);
          }
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    clearForm() {
      this.data_allowances = [];
      this.jsondatatax.tax_cal = [];
      this.jsondatatax.tax_detail = [];
    },

    async onSave() {
      //this.commitSetShowLoading(true);
      /**setdata */
      this.jsondatatax = {
        year_tax: null,
        tax_detail: [],
        tax_cal: [],
        creator_code: null,
        company_id: localStorage._company_guid,
      };
      let v = this;
      console.log("income: ", this.income);
      console.log("json: ", this.jsondatatax);
      //this.jsondatatax.tax_cal = this.data_tax;
      // console.log("tax_cal: ", this.jsondatatax.tax_cal);
      //  if (this.data_tax.length == 0) {
      //   for (let index = 1; index < this.taxstructure.length; index++) {
      //     this.jsondatatax.tax_cal.push({
      //       line_number: this.taxstructure[index].line_number,
      //       from_value: this.taxstructure[index].from_value,
      //       to_value: this.taxstructure[index].to_value,
      //       tax: this.taxstructure[index].tax,
      //       basiccal: this.taxstructure[index].basiccal,
      //       deductline: this.taxstructure[index].deductline
      //     });
      //   }
      // } else {
      //   this.jsondatatax.tax_cal = this.data_tax;
      // }
      /*basiccal*/
      console.log("data tax : ", this.data_tax);
      this.data_tax.forEach(function(element, index) {
        if (index + 1 == v.data_tax.length) {
          element.basiccal = 0;
        } else if (index > 0) {
          element.basiccal = element.to_value - v.data_tax[index - 1].to_value;
          console.log("basiccal", element.basiccal);
        } else {
          element.basiccal = element.to_value;
        }
        element.deductline = element.basiccal * (element.tax / 100);
        element.company_id = localStorage._company_guid;
      });

      this.jsondatatax.tax_cal = this.data_tax;
      console.log(this.jsondatatax.tax_cal);

      for (let i = 0; i < this.tax_detail.length; i++) {
        if (this.tax_detail[i].name == "add_income") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.income,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "expensed") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.less_exp_base,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "spouse") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_spouse,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "personal") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_person,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "childen") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_child_base,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "residence") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_insurance_base,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "parent") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_parent_base,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "handicapped") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_handucap_base,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "insurance") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_inc_residence_base,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "parent_insurance") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_parent_insurance_base,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "long_insurance") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_long_insurance,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "LTF") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_ltf,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "RMF") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_rmf,
            company_id: localStorage._company_guid,
          });
        } else {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.tax_detail[i].max,
            company_id: localStorage._company_guid,
          });
        }
      }
      console.log("data_allowances length" + this.data_allowances.length);
      for (let i = 0; i < this.data_allowances.length; i++) {
        if (this.data_allowances[i].name != null) {
          this.jsondatatax.tax_detail.push({
            name: this.data_allowances[i].name,
            type: this.data_allowances[i].type,
            percent: this.data_allowances[i].percent,
            max: this.data_allowances[i].max,
            company_id: localStorage._company_guid,
          });
          console.log("add data_allowances");
        } else {
          console.log("not add data_allowances");
        }
      }

      //   this.data_tax.forEach(function(element, index) {
      //   if (index + 1 == this.data_tax.length) {
      //     element.basiccal = 0;
      //   } else if (index > 0) {
      //     element.basiccal =
      //       element.to_value - this.data_tax[index - 1].to_value;
      //   } else {
      //     element.basiccal = element.to_value;
      //   }
      //   element.deductline = element.basiccal * (element.tax / 100);
      // });

      var year;

      if (this.years.name != null) {
        year = this.years.name;
      } else {
        year = this.years;
      }
      console.log("onsave year" + year);
      this.jsondatatax.year_tax = year;
      this.jsondatatax.creator_code = localStorage._usercode;

      this.jsondatatax.company_id = localStorage._company_guid;
      console.log(this.jsondatatax);
      await SettingService.createTaxdetail(this.jsondatatax)
        .then((res) => {
          console.log("save success");
          this.snackbarcolor = "success";
          this.snackmsg = "save success";
          this.snackbar = true;
          this.getTaxDetail();
        })
        .catch((err) => {
          this.commitSetShowLoading(false);
          this.snackbar = true;
          this.snackbarcolor = "error";
          this.snackmsg = "error";
          console.log(err.response.data);
        });
    },
    //*update data*//
    async onUpdate() {
      console.log("income: ", this.income);
      console.log("jsondatatax: ", this.jsondatatax);
      console.log("update year: ", this.years);
      this.jsondatatax.tax_cal = [];
      this.jsondatatax.tax_detail = [];
      var year;
      let v = this;
      if (this.years.name != null) {
        year = this.years.name;
      } else {
        year = this.years;
      }
      this.jsondatatax.year_tax = year;
      this.jsondatatax.creator_code = localStorage._usercode;
      this.jsondatatax.company_id = localStorage._company_guid;
      console.log("555", this.taxstructure.length);

      this.data_tax.forEach(function(element, index) {
        if (index + 1 == v.data_tax.length) {
          element.basiccal = 0;
        } else if (index > 0) {
          element.basiccal = element.to_value - v.data_tax[index - 1].to_value;
          console.log("basiccal", element.basiccal);
        } else {
          element.basiccal = element.to_value;
        }
        element.deductline = element.basiccal * (element.tax / 100);
      });
      console.log(this.data_tax);
      if (this.data_tax.length == 0) {
        this.data_tax = this.taxstructure;
      }
      this.jsondatatax.tax_cal = this.data_tax;
      console.log(this.jsondatatax.tax_cal);

      for (let i = 0; i < this.tax_detail.length; i++) {
        if (this.tax_detail[i].name == "add_income") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.income,
          });
        } else if (this.tax_detail[i].name == "expensed") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.less_exp_base,
          });
        } else if (this.tax_detail[i].name == "spouse") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_spouse,
          });
        } else if (this.tax_detail[i].name == "personal") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_person,
          });
        } else if (this.tax_detail[i].name == "childen") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_child_base,
          });
        } else if (this.tax_detail[i].name == "residence") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_insurance_base,
          });
        } else if (this.tax_detail[i].name == "parent") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_parent_base,
          });
        } else if (this.tax_detail[i].name == "handicapped") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_handucap_base,
          });
        } else if (this.tax_detail[i].name == "insurance") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_inc_residence_base,
          });
        } else if (this.tax_detail[i].name == "parent_insurance") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_parent_insurance_base,
          });
        } else if (this.tax_detail[i].name == "long_insurance") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_long_insurance,
          });
        } else if (this.tax_detail[i].name == "LTF") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_ltf,
          });
        } else if (this.tax_detail[i].name == "RMF") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_rmf,
          });
        } else {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.tax_detail[i].max,
          });
        }
      }
      console.log("data_allowances length" + this.data_allowances.length);
      for (let i = 0; i < this.data_allowances.length; i++) {
        if (this.data_allowances[i].name != null) {
          this.jsondatatax.tax_detail.push({
            name: this.data_allowances[i].name,
            type: this.data_allowances[i].type,
            percent: this.data_allowances[i].percent,
            max: this.data_allowances[i].max,
          });
          console.log("add data_allowances");
        } else {
          console.log("not add data_allowances");
        }
      }

      console.log(this.jsondatatax);
      await SettingService.updateTaxdetail(this.jsondatatax)
        .then((res) => {
          console.log("update success");
          this.snackbarcolor = "success";
          this.snackmsg = "update success";
          this.snackbar = true;
        })
        .catch((err) => {
          this.commitSetShowLoading(false);
          this.snackbar = true;
          this.snackbarcolor = "error";
          this.snackmsg = "error";
          console.log(err.response.data);
        });
    },
    createyear() {
      var curryears = new Date().toISOString().substr(0, 4);
      var startyear = parseInt(curryears) - 10;
      var endyear = parseInt(curryears) + 10;
      console.log("curryears", curryears);
      console.log("startyear", startyear);
      console.log("endyear", endyear);
      for (var d = startyear; d <= endyear; d++) {
        this.items.push({ name: d });
      }
      console.log(this.items);

      console.log("year", this.years.name);
      console.log("tax detail", this.taxsetting);
    },
    plusTax() {
      let line = this.taxstructure.length + 1;
      this.data_tax.push({
        line_number: line,
        from_value: 0,
        to_value: 0,
        tax: 0,
        basiccal: 0,
        deductline: 0,
        company_id: localStorage._company_guid,
      });
      console.log("line", line);
    },
    delTax() {
      this.data_tax.splice(-1, 1);
    },
    plusallowances() {
      let line = this.data_allowances.length + 1;
      this.data_allowances.push({
        type: 0,
        percent: 0,
        name: null,
        max: 0,
        company_id: localStorage._company_guid,
      });
    },
    delallowances() {
      this.data_allowances.splice(-1, 1);
    },
    thousandSep(nStr) {
      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    getTaxDetail() {
      console.log("get taxdetail: ", this.jsondatatax);
      var year;
      if (this.years.name != null) {
        year = this.years.name;
      } else {
        year = this.years;
      }
      SettingService.getTaxdetail(year)
        .then((res) => {
          console.log("input years: " + year);
          /*start chang year not data*/
          this.jsondatatax.tax_detail = [];
          this.data_allowances = [];
          this.data_allowances.push(
            {
              type: 0,
              percent: 0,
              name: null,
              max: 0,
            },
            {
              type: 0,
              percent: 0,
              name: null,
              max: 0,
            },
            {
              type: 0,
              percent: 0,
              name: null,
              max: 0,
            }
          );
          this.taxsetting.less_exp_rate = 50;
          this.taxsetting.less_exp_base = 100000;
          this.taxsetting.reduce_person = 60000;
          this.taxsetting.reduce_spouse = 60000;
          this.taxsetting.reduce_child_base = 90000;
          this.taxsetting.reduce_parent_base = 60000;
          this.taxsetting.reduce_handucap_base = 30000;
          this.taxsetting.reduce_insurance_base = 100000;
          this.taxsetting.reduce_parent_insurance_base = 15000;
          this.taxsetting.reduce_inc_residence_base = 100000;
          this.taxsetting.reduce_ltf = 500000;
          this.taxsetting.reduce_long_insurance = 200000;
          this.taxsetting.reduce_rmf = 500000;

          /*close*/
          console.log("data", res);
          this.checkdata = res.data;
          console.log(this.checkdata);
          if (res.data != "") {
            this.jsondatatax = res.data;
            console.log(res.data);
            console.log(this.jsondatatax);
            //**return data *//
            this.data_allowances = [];

            this.taxsetting;
            this.data_tax = this.taxstructure;
            if (this.jsondatatax.tax_cal.length > 0) {
              this.data_tax = this.jsondatatax.tax_cal;
            }

            console.log("have data", this.data_tax);
            for (let index = 0; index < this.jsondatatax.tax_detail.length; index++) {
              if (this.jsondatatax.tax_detail[index].name == "add_income") {
                this.income = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "expensed") {
                this.taxsetting.less_exp_base = this.jsondatatax.tax_detail[index].max;
                this.taxsetting.less_exp_rate = this.jsondatatax.tax_detail[index].percent;
              } else if (this.jsondatatax.tax_detail[index].name == "spouse") {
                this.taxsetting.reduce_spouse = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "personal") {
                this.taxsetting.reduce_person = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "childen") {
                this.taxsetting.reduce_child_base = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "residence") {
                this.taxsetting.reduce_insurance_base = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "parent") {
                this.taxsetting.reduce_parent_base = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "handicapped") {
                this.taxsetting.reduce_handucap_base = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "insurance") {
                this.taxsetting.reduce_inc_residence_base = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "parent_insurance") {
                this.taxsetting.reduce_parent_insurance_base = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "long_insurance") {
                this.taxsetting.reduce_long_insurance = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "LTF") {
                this.taxsetting.reduce_ltf = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "RMF") {
                this.taxsetting.reduce_rmf = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[12]) {
                this.data_allowances.push({
                  name: this.jsondatatax.tax_detail[index].name,
                  type: this.jsondatatax.tax_detail[index].type,
                  percent: this.jsondatatax.tax_detail[index].percent,
                  max: this.jsondatatax.tax_detail[index].max,
                });
                console.log("getTaxDetail :", this.data_allowances);
              }
            }
          } else if (res == "") {
            console.log("not data year", this.years);
            this.jsondatatax = [];
            this.income = 0;
            this.jsondatatax.year_tax = "";
            this.jsondatatax.tax_detail = [];
            this.jsondatatax.tax_cal = [];
            this.jsondatatax.creator_code = "";
            this.data_allowances = [];
            console.log("not data", this.data_tax);
            this.getTaxSetting();
          }
          //**close data */
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
  },
};
</script>
